import * as React from 'react'

export const WelcomeSvg: React.FC = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1639.75 1235.39"
      data-testid="welcome-svg"
    >
      <defs>
        <style>
          {
            '.cls-1,.cls-10,.cls-12,.cls-17,.cls-23,.cls-32,.cls-7,.cls-8,.cls-9{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#edd3e6;}.cls-4,.cls-6{fill:#e2b5d9;}.cls-4{opacity:0.3;}.cls-5{fill:#ce95c6;}.cls-7,.cls-8,.cls-9{stroke:#ce95c6;}.cls-10,.cls-12,.cls-17,.cls-23,.cls-32,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-10,.cls-7{stroke-width:2.65px;}.cls-8{stroke-width:2.63px;}.cls-9{stroke-width:2.61px;}.cls-10,.cls-12{stroke:#e2b5d9;}.cls-11{fill:#df9dd8;}.cls-12,.cls-17,.cls-23,.cls-32{stroke-linecap:round;}.cls-12{stroke-width:16.36px;stroke-dasharray:1 54.52;}.cls-13{fill:#ffd0b6;}.cls-14{fill:#371447;}.cls-15,.cls-24,.cls-30{fill:#e1769e;}.cls-15{opacity:0.25;}.cls-16{fill:#6d4d26;}.cls-17,.cls-23,.cls-32{stroke:#371447;}.cls-17{stroke-width:2.65px;}.cls-18{fill:#954293;}.cls-19{fill:#895433;}.cls-20{fill:#8a3575;}.cls-21{fill:#5f2779;}.cls-22{fill:#211a19;}.cls-23{stroke-width:2.84px;}.cls-24{opacity:0.1;}.cls-25{fill:#724025;}.cls-26{fill:#ffb7d1;}.cls-27{fill:#ff92ba;}.cls-28{fill:#ffcebb;}.cls-29{fill:#dea382;}.cls-30{opacity:0.2;}.cls-31{fill:#3d0d01;}.cls-32{stroke-width:2.53px;}.cls-33{fill:#c1886c;}.cls-34{fill:#22d6b7;}.cls-35{fill:#cb3974;}.cls-36{fill:#7d3ca0;}.cls-37{fill:#db598c;}.cls-38{fill:#9eefe1;}.cls-39{fill:#fee6ff;}'
          }
        </style>
        <clipPath id="clip-path">
          <rect
            className="cls-1"
            x="145.78"
            y="145.78"
            width="1348.19"
            height="943.82"
          />
        </clipPath>
      </defs>
      <g className="cls-2">
        <rect
          className="cls-3"
          x="145.78"
          y="144.22"
          width="1348.19"
          height="945.38"
        />
        <circle className="cls-4" cx="356.48" cy="644.57" r="176.13" />
        <circle className="cls-4" cx="1324.9" cy="350.29" r="108.99" />
        <circle className="cls-4" cx="687.55" cy="350.29" r="108.99" />
        <circle className="cls-4" cx="731.47" cy="881.56" r="121.39" />
        <rect
          className="cls-5"
          x="794.69"
          y="144.22"
          width="15.11"
          height="125.74"
        />
        <circle className="cls-6" cx="802.25" cy="459.4" r="192.09" />
        <path
          className="cls-6"
          d="M731.52,459.4h-63A427.43,427.43,0,0,0,672.39,519c17.45,3.08,38.26,6.15,61.59,8.44C732,504,731.28,481.13,731.52,459.4Z"
        />
        <path
          className="cls-5"
          d="M735.3,391.24c-23.66,2.29-44.78,5.37-62.46,8.48a450.3,450.3,0,0,0-4.31,59.68h63C731.8,435.1,733.23,412.16,735.3,391.24Z"
        />
        <path
          className="cls-3"
          d="M672.39,519a409.35,409.35,0,0,0,12.35,58.57,450.5,450.5,0,0,0,57.71,11.86,615.38,615.38,0,0,1-8.47-62C710.65,525.14,689.84,522.07,672.39,519Z"
        />
        <path
          className="cls-3"
          d="M743.84,329.18a452.37,452.37,0,0,0-58.88,12,453,453,0,0,0-12.12,58.55c17.68-3.11,38.8-6.19,62.46-8.48C737.62,367.69,740.73,346.71,743.84,329.18Z"
        />
        <path
          className="cls-3"
          d="M872.53,528.48A610.83,610.83,0,0,0,933.14,520a427.85,427.85,0,0,0,4-60.61h-62C875.33,481.46,874.62,504.64,872.53,528.48Z"
        />
        <path
          className="cls-5"
          d="M734,527.43a615.38,615.38,0,0,0,8.47,62,447.44,447.44,0,0,0,59.8,4.27V531.18C777.91,530.92,754.94,529.49,734,527.43Z"
        />
        <path
          className="cls-6"
          d="M802.25,531.18v62.51a426.74,426.74,0,0,0,61.89-4.21,612.64,612.64,0,0,0,8.39-61A702.4,702.4,0,0,1,802.25,531.18Z"
        />
        <path
          className="cls-5"
          d="M864.14,589.48A410.8,410.8,0,0,0,921,577.2,409.45,409.45,0,0,0,933.14,520a610.83,610.83,0,0,1-60.61,8.47A612.64,612.64,0,0,1,864.14,589.48Z"
        />
        <path
          className="cls-3"
          d="M802.25,387.61c-23.84.26-46.35,1.64-67,3.63-2.07,20.92-3.5,43.86-3.78,68.16h70.73Z"
        />
        <path
          className="cls-6"
          d="M932.67,398.69a453.51,453.51,0,0,0-11.87-57.17,410.73,410.73,0,0,0-58-12.4c3.07,17.29,6.13,37.92,8.45,61.07A613.82,613.82,0,0,1,932.67,398.69Z"
        />
        <path
          className="cls-5"
          d="M802.25,387.61V325.1a449.7,449.7,0,0,0-58.41,4.08c-3.11,17.53-6.22,38.51-8.54,62.06C755.9,389.25,778.41,387.87,802.25,387.61Z"
        />
        <path
          className="cls-6"
          d="M731.52,459.4c-.24,21.73.44,44.56,2.46,68,21,2.06,43.93,3.49,68.27,3.75V459.4Z"
        />
        <path
          className="cls-6"
          d="M802.25,387.61V459.4h72.83c-.27-24.71-1.75-48-3.87-69.21C847.42,388.1,824.27,387.38,802.25,387.61Z"
        />
        <path
          className="cls-6"
          d="M802.25,531.18a702.4,702.4,0,0,0,70.28-2.7c2.09-23.84,2.8-47,2.55-69.08H802.25Z"
        />
        <path
          className="cls-6"
          d="M871.21,390.19c-2.32-23.15-5.38-43.78-8.45-61.07a426.48,426.48,0,0,0-60.51-4v62.51C824.27,387.38,847.42,388.1,871.21,390.19Z"
        />
        <path
          className="cls-6"
          d="M640,562.17a193.07,193.07,0,0,0,60.56,60.18,408.93,408.93,0,0,1-15.77-44.79C660,570.74,644,564,640,562.17Z"
        />
        <path
          className="cls-5"
          d="M672.39,519c-31.94-5.64-52.55-11.32-56.38-12.42A190.94,190.94,0,0,0,640,562.17c4,1.79,20,8.57,44.79,15.39A409.35,409.35,0,0,1,672.39,519Z"
        />
        <path
          className="cls-6"
          d="M742.45,589.42A538.62,538.62,0,0,0,756.32,646a538.62,538.62,0,0,1-13.87-56.53,450.5,450.5,0,0,1-57.71-11.86,408.93,408.93,0,0,0,15.77,44.79,191.27,191.27,0,0,0,101.74,29.14v-57.8A447.44,447.44,0,0,1,742.45,589.42Z"
        />
        <path
          className="cls-6"
          d="M871.21,390.19c2.12,21.2,3.6,44.5,3.87,69.21h62a448.59,448.59,0,0,0-4.46-60.71A613.82,613.82,0,0,0,871.21,390.19Z"
        />
        <path
          className="cls-6"
          d="M994.34,459.4H937.13a427.85,427.85,0,0,1-4,60.61,537.45,537.45,0,0,0,55.29-13.63A537.45,537.45,0,0,1,933.14,520,409.45,409.45,0,0,1,921,577.2a407,407,0,0,0,43.8-15.49A407,407,0,0,1,921,577.2a407.39,407.39,0,0,1-15.49,44.17A191.92,191.92,0,0,0,994.34,459.4Z"
        />
        <path
          className="cls-6"
          d="M864.14,589.48a536.43,536.43,0,0,1-13.69,55.9,190.77,190.77,0,0,0,55.09-24A407.39,407.39,0,0,0,921,577.2,410.8,410.8,0,0,1,864.14,589.48Z"
        />
        <path
          className="cls-6"
          d="M802.25,593.69v57.8a191.94,191.94,0,0,0,48.2-6.11,536.43,536.43,0,0,0,13.69-55.9A426.74,426.74,0,0,1,802.25,593.69Z"
        />
        <path
          className="cls-6"
          d="M668.53,459.4H610.16A192,192,0,0,0,616,506.57c3.83,1.1,24.44,6.78,56.38,12.42A427.43,427.43,0,0,1,668.53,459.4Z"
        />
        <path
          className="cls-5"
          d="M920.8,341.52c-6.76-24.36-13.42-40.06-15.2-44.06a191,191,0,0,0-55.15-24c1,3.56,6.67,23.95,12.31,55.71A410.73,410.73,0,0,1,920.8,341.52Z"
        />
        <path
          className="cls-3"
          d="M672.84,399.72c-32.19,5.67-53,11.4-56.83,12.5a192.12,192.12,0,0,0-5.85,47.18h58.37A450.3,450.3,0,0,1,672.84,399.72Z"
        />
        <path
          className="cls-3"
          d="M862.76,329.12c-5.64-31.76-11.3-52.15-12.31-55.71a192.46,192.46,0,0,0-48.2-6.1V325.1A426.48,426.48,0,0,1,862.76,329.12Z"
        />
        <path
          className="cls-6"
          d="M964.83,357.08a409,409,0,0,0-44-15.56,453.51,453.51,0,0,1,11.87,57.17,538.65,538.65,0,0,1,55.76,13.72,538.65,538.65,0,0,0-55.76-13.72,448.59,448.59,0,0,1,4.46,60.71h57.21A192,192,0,0,0,905.6,297.46c1.78,4,8.44,19.7,15.2,44.06A409,409,0,0,1,964.83,357.08Z"
        />
        <path
          className="cls-6"
          d="M743.84,329.18c6.23-35.09,12.48-56.33,12.48-56.33s-6.25,21.24-12.48,56.33a449.7,449.7,0,0,1,58.41-4.08V267.31a191.19,191.19,0,0,0-101.74,29.14S692.81,313,685,341.17A452.37,452.37,0,0,1,743.84,329.18Z"
        />
        <path
          className="cls-5"
          d="M700.51,296.45A193,193,0,0,0,640,356.62c4-1.8,20.12-8.61,45-15.45C692.81,313,700.51,296.45,700.51,296.45Z"
        />
        <path
          className="cls-3"
          d="M933.31,519.28c30.86-5.45,50.78-10.95,54.49-12A184.85,184.85,0,0,1,964.66,561c-3.91,1.73-19.36,8.28-43.29,14.87A396.07,396.07,0,0,0,933.31,519.28Z"
        />
        <path
          className="cls-5"
          d="M932.05,400c31.93,5.64,52.54,11.32,56.38,12.41a191.06,191.06,0,0,0-23.94-55.6c-4-1.79-20-8.57-44.79-15.39A411.14,411.14,0,0,1,932.05,400Z"
        />
        <path className="cls-7" d="M700.51,296.45s-72,154.21,0,325.9" />
        <path className="cls-8" d="M905.6,297.46s71,153.73,0,324.89" />
        <path className="cls-9" d="M643.6,562.17s152,71,321.23,0" />
        <path className="cls-7" d="M638.93,357.08s154.21-72,325.9,0" />
        <path className="cls-7" d="M756.32,272.85s-55.92,189.81,0,373.1" />
        <path className="cls-7" d="M850.29,272.85s55.92,189.81,0,373.1" />
        <path className="cls-7" d="M615.33,506.38s189.82,55.92,373.1,0" />
        <path className="cls-7" d="M615.33,412.41s189.82-55.92,373.1,0" />
        <line
          className="cls-7"
          x1="802.25"
          y1="267.31"
          x2="802.25"
          y2="651.49"
        />
        <line className="cls-7" x1="610.16" y1="459.4" x2="994.34" y2="459.4" />
        <circle className="cls-10" cx="802.25" cy="459.4" r="192.09" />
        <path
          className="cls-11"
          d="M416.24,250.85l-15.69-4.22a6.47,6.47,0,0,1,0-12.5l15.69-4.23a6.47,6.47,0,0,0,4.57-4.57L425,209.65a6.47,6.47,0,0,1,12.5,0l4.23,15.68a6.48,6.48,0,0,0,4.56,4.57L462,234.13a6.47,6.47,0,0,1,0,12.5l-15.69,4.22a6.48,6.48,0,0,0-4.56,4.57l-4.23,15.69a6.47,6.47,0,0,1-12.5,0l-4.22-15.69A6.47,6.47,0,0,0,416.24,250.85Z"
        />
        <path
          className="cls-12"
          d="M155.17,156s85.29,244.59,307.32,220.23S792.58,145.78,792.58,145.78s172.77,506.12,689.68,360.6"
        />
        <path
          className="cls-13"
          d="M1177.34,475.14s20,40.69,14.84,56.26h63.59s-9.86-54.33-18.73-66.4S1177.34,475.14,1177.34,475.14Z"
        />
        <path
          className="cls-14"
          d="M1188.84,487.28c-4.26,0,46.58-59.07,50.24-54.72,5,5.88,9.62,66.47,9.62,66.47C1246.73,493.43,1233,487.11,1188.84,487.28Z"
        />
        <path
          className="cls-13"
          d="M1147.43,449.67l-2.3-.76c-3.49-1.15-9.54-2.66-9.94-6.54-.58-5.71,5-10.45,7-15.61a64.78,64.78,0,0,0,3.75-25.21c-.23-6.46-4-12.71-5.13-19.14-1.16-6.81-.27-13.56,4.45-19,4.15-4.76,9.91-7.9,15.64-10.69,2.5-1.22,5-2.4,7.61-3.48a70.85,70.85,0,0,1,15.18-4.65c20.79-3.59,42.84,4.41,56.28,20.27s19.15,37,18.92,57.54c-.13,11.58-2.27,24.95-7,35.58s-12,20.69-22.33,26.43c-57,31.67-80.44-14.26-81.94-30.81C1147.51,452.27,1147.46,451,1147.43,449.67Z"
        />
        <ellipse
          className="cls-15"
          cx="1186.88"
          cy="424.1"
          rx="16.12"
          ry="15.7"
        />
        <path
          className="cls-16"
          d="M1141.58,376.46c-21.83.67-45.15-64.22-9.23-54.21,57.48,16,92.44-18.77,119.22,9.68s41.39,34.64,2.71,119.83c0,0-15.84-58.87-34.81-65.93C1185.09,373,1141.58,376.46,1141.58,376.46Z"
        />
        <path
          className="cls-13"
          d="M1233.94,408.16c-.12.85,1.74-3.14,1.64-2.39a36.07,36.07,0,0,0-.24,9.62c.51,4.51,2.29,9.05,5.78,12.06,1.8,1.55,4.44,2.66,6.58,1.59a7,7,0,0,0,2.2-2c7.16-8.93,14.5-17.82,12.75-29.79-.62-4.23-2.21-8.45-5.32-11.46s-6.95-5.72-11.08-4.89c0,0-13.23,1.6-11.74,23.31"
        />
        <path
          className="cls-14"
          d="M1249.66,414.38c7.12-5.4,3.64-14.14-1.51-19.53-1.18-1.25-3.07.64-1.88,1.88,3.75,3.94,7.68,11.07,2,15.34-1.35,1,0,3.34,1.35,2.31Z"
        />
        <path className="cls-17" d="M1197,455.06s-6.48,20.19-29.77,18.45" />
        <polygon
          className="cls-18"
          points="1149.53 872.82 1149.53 1091.22 1291.45 1091.22 1291.45 1049.95 1327.12 1091.22 1465.39 1089.73 1375.69 840.16 1149.53 872.82"
        />
        <path
          className="cls-19"
          d="M225.3,664.06c3.91-4.54,9.42-8,18-10.46a166.6,166.6,0,0,1,43.84-6c16.14-.07,34.23,2.38,37,13.28C329.35,681.17,261,847.38,261,847.38s-76.51,174.1-140,202.27c0,0,8.52-40.76-10.38-51.73,18.21-28.33,26.52-53.84,42.82-82.86,18.33-32.63,31.41-63.59,36.81-99.11,6.93-45.54,12.28-90.4,26.67-135C219.11,674.18,221.41,668.58,225.3,664.06Z"
        />
        <polygon
          className="cls-20"
          points="265.53 920.69 145.78 1181.43 467.88 1181.43 425.05 917.41 265.53 920.69"
        />
        <path
          className="cls-21"
          d="M423.12,886.2c.2,3.3-33.25,23.67-76.39,26.26s-79.62-13.58-79.82-16.87,34.61-8.07,77.75-10.66S422.92,882.91,423.12,886.2Z"
        />
        <path
          className="cls-22"
          d="M356.48,380.6s-30.81-41.07-77.74-6.32c0,0-65-6.77-57.77,51.9,0,0-62.29,39.26-24.82,62.28,0,0-37.72,59.67,12.18,66.35,0,0-9.57,38.45,23,44.68,0,0,20.67,44.94,70,19.11,0,0,60.76,29,90.39-9.29,0,0,33.32,8.6,40-24.27,0,0,42.82-15.64,16.7-65.44,0,0,33.85-4.72,16.25-44.43,0,0,20.41-48.25-23.47-49,0,0,2.41-31.1-38-30.36C403.18,395.82,389.77,364.28,356.48,380.6Z"
        />
        <path
          className="cls-19"
          d="M375,581.07s-3,45.45,3.87,62.58L306,649.22s-6-60.51,2.71-74.82S375,581.07,375,581.07Z"
        />
        <path
          className="cls-14"
          d="M361.79,604.79c4.68-.31-52-44.31-55.54-39-5.32,7.89-2.14,54-2.14,54S316.51,607.78,361.79,604.79Z"
        />
        <path
          className="cls-19"
          d="M366.33,440.55c2.91,1,5.79,2.13,8.63,3.31,6.52,2.69,13.09,5.76,18,10.8,15.08,15.37,9.06,32.88,8.71,53.33-.27,16.21-3.7,32.25-3.95,48.46-.29,18.76-22.26,72.37-87.35,41.23-11.8-5.64-20.63-16.38-26.66-28s-9.47-26.49-10.56-39.53c-1.94-23.14,2.59-47.4,16-66.33a66.42,66.42,0,0,1,60.07-27.32A75.35,75.35,0,0,1,366.33,440.55Z"
        />
        <path className="cls-23" d="M356.48,572.18s-19.64,12.08-37-5.6" />
        <circle className="cls-24" cx="380.83" cy="532.71" r="15.01" />
        <path
          className="cls-25"
          d="M349.45,513.44c4.81,8.13,4.23,26.69,3.75,31.61-.3,3-.73,6.14-2.85,8.27-3.09,3.11-8.29,2.71-12.74,2-4.82-.72-10.41-2-12.4-6.34-1.06-2.29-.8-4.91-.4-7.37a79.53,79.53,0,0,1,6.75-21.46c1.49-3.12,3.28-6.25,6.16-8.27C343.38,508,347.07,509.42,349.45,513.44Z"
        />
        <path
          className="cls-19"
          d="M294,514.19c.22,1-2.39-3.75-2.2-2.83A46.32,46.32,0,0,1,293,523.29c-.2,5.64-1.94,11.43-5.89,15.47-2,2.09-5.12,3.69-7.81,2.56a8.65,8.65,0,0,1-2.84-2.28c-9.46-10.46-19.13-20.85-18.1-35.87.37-5.29,1.91-10.68,5.39-14.68s7.89-7.72,12.95-7.05c0,0,16.14.82,16.31,27.91"
        />
        <path
          className="cls-14"
          d="M267.93,498.54a13.51,13.51,0,0,0,2.23,22.1,1.5,1.5,0,0,0,1.51-2.59c-6.64-3.9-7.33-12.33-1.61-17.39,1.45-1.28-.68-3.4-2.13-2.12Z"
        />
        <circle className="cls-24" cx="299.4" cy="526.54" r="15.01" />
        <path
          className="cls-22"
          d="M246.69,474.47S282.43,517.7,314.41,488c0,0,14.48,11.86,37.87,10.71,17.6-.87,26.61-10.71,26.61-10.71s23.53,25.23,32.56,23.52S431.28,439,431.28,439L318,416.77Z"
        />
        <polygon
          className="cls-19"
          points="305.99 649.22 337.96 788.07 378.89 643.65 305.99 649.22"
        />
        <path
          className="cls-19"
          d="M368.68,695.91s62.21,167.45,128.61,187.93c84.41,26,105.21-196.33,105.21-196.33L561.25,672.8S518,796.81,501,785.28,436.8,657.21,436.8,657.21s-11.64-28.79-62.38-8C327.36,668.5,368.68,695.91,368.68,695.91Z"
        />
        <path
          className="cls-5"
          d="M270.36,652.21,304.15,647a2.14,2.14,0,0,1,2.27,1.25l34,78a2.12,2.12,0,0,0,3.9,0l34-81.42a2.11,2.11,0,0,1,1.78-1.29l28.74-2.38a2.13,2.13,0,0,1,2.26,1.72s26.17,81,14.44,135.93c-12.38,58-11.67,113.24-11.67,113.24S339,918.16,281.57,907.17c0,0-34.78-134.72-13-253A2.24,2.24,0,0,1,270.36,652.21Z"
        />
        <path
          className="cls-22"
          d="M276.15,488.16l2.28,30.69a1.55,1.55,0,0,0,2.94.55l18-38Z"
        />
        <circle className="cls-26" cx="274.82" cy="535.87" r="3.16" />
        <path
          className="cls-20"
          d="M267.19,895.68s125.87,15.8,155.93-9.48l1.93,31.21S325.09,956.29,265,929Z"
        />
        <path
          className="cls-19"
          d="M615,577.11c-7.6-9.53-13.55,29.45-18,22.63s2.77-39.4,6.87-48.24,9.88-20-2.91-18.69c-5.23.54-12.73,11.49-20,25.35a50.92,50.92,0,0,1,1.35-6.38c2.83-9.32,7-21.17-5.47-18.11s-20.66,66-21.34,82.46A69,69,0,0,0,560,642.85c.86,3.51,1.81,6.47,2.59,8.71,2.48,7.14-4.17,25.94-4.17,25.94l0,0-12,35.1s46.66,38.25,51.27,17c6.07-28,9.46-80.16,9.46-80.16s3.08-5.39,7.44-15C620,622.78,620.72,584.33,615,577.11Z"
        />
        <circle className="cls-5" cx="332.61" cy="964.49" r="4.91" />
        <circle className="cls-5" cx="332.61" cy="927.38" r="4.91" />
        <circle className="cls-5" cx="332.61" cy="1013.72" r="4.91" />
        <circle className="cls-5" cx="331.12" cy="1062.95" r="4.91" />
        <circle className="cls-5" cx="329.63" cy="1112.18" r="4.91" />
        <circle className="cls-5" cx="326.64" cy="1161.4" r="4.91" />
        <path
          className="cls-19"
          d="M68.47,1100.08c-12.19-.19,15-28.73,6.88-28.1s-29.48,26.29-34,34.93-9.77,20-16.56,9.14c-2.78-4.47,1.3-17.1,7.84-31.3a51.63,51.63,0,0,0-4.22,5c-5.65,7.94-12.47,18.49-17.67,6.74s39.6-56.71,52.19-67.3a69,69,0,0,1,23.91-12.76c3.3-1.47,6.23-2.52,8.48-3.28,7.16-2.4,18-19.16,18-19.16h0l20.43-31s58.81,13.53,44.84,30.15c-18.43,21.92-57.63,56.5-57.63,56.5s-2.39,5.75-7.29,15C107.68,1076.13,77.7,1100.23,68.47,1100.08Z"
        />
        <path
          className="cls-13"
          d="M1024.62,154.34c-10.72-9.19-9,36.46-15.61,29.67s-5.4-45.44-2.65-56.39,6.9-24.9-7.37-20.64c-5.83,1.74-12,15.83-17.22,33.18a59.55,59.55,0,0,1,.16-7.56c1.19-11.22,3.38-25.62-10.16-19.42s-9.18,79.62-6.39,98.47a79.92,79.92,0,0,0,11,29.44c1.74,3.8,3.47,7,4.84,9.35,4.37,7.58.88,30.43.88,30.43l0,0-6,42.55s61.41,33.42,62,8.27c.84-33.17-6.63-93.28-6.63-93.28s2.34-6.81,5.23-18.64C1040.25,205.23,1032.74,161.3,1024.62,154.34Z"
        />
        <path
          className="cls-27"
          d="M1001.19,483.82l128,212.21,5.63-166.62-55-80.32a138.49,138.49,0,0,1-23.64-65.23l-11.92-125.7-79.42-9,17.09,176.49A138.47,138.47,0,0,0,1001.19,483.82Z"
        />
        <path
          className="cls-28"
          d="M1335.78,1061.67c5.55,11.41,20.48-26.84,23.48-18.88s-11.8,39.4-18,47.45-14.6,18.06-1.31,19.65c5.44.65,15.55-8.77,26.07-21.2a53.92,53.92,0,0,1-2.83,6.17c-5,8.83-12,19.92,1.43,19.65s36-62.37,40.48-78.92a71.77,71.77,0,0,0,1.49-28.19c-.07-3.75-.37-7-.65-9.44-.88-7.81,10.16-25.4,10.16-25.4l0,0,20.19-32.93s-38.69-49.52-48.2-29c-12.56,27-27.9,79.28-27.9,79.28s-4.36,4.79-11,13.51C1341.09,1014.12,1331.57,1053,1335.78,1061.67Z"
        />
        <path
          className="cls-27"
          d="M1457.18,733.55c-3.71-10.33-8.28-20.42-12.83-30.4q-37-81.31-74-162.62c-1.61-3.54-3.38-7.27-6.64-9.39-2.83-1.84-6.35-2.18-9.72-2.46l-73.87-6.27c-7.3-.62-14.66-1.24-21.95-.47-11.2,1.2-22,5.67-33.21,6-10.51.36-20.78-2.87-31.21-4.29-13.89-1.9-28-.57-41.68,2-6.93,1.3-13.8,2.91-20.65,4.61-2,.5-5.51.67-7.21,2-1.9,1.48-1.59,5.31-1.85,7.46-3.37,27.86-3.67,56-2.34,84,1.34,28.2,4.31,56.29,7.43,84.33s6.42,56.24,8.43,84.46q.47,6.54.84,13.09c2,35.25,2.11,72.65,20.84,102.57,12.22,19.5,31.41,33.88,52.21,43.73,24.39,11.54,51.87,17.37,78.63,13.94s52.65-16.6,69.14-38l-5.21,26.49c-.43,2.16-.84,4.49.09,6.48,1.19,2.57,4.15,3.71,6.83,4.62l59.45,20.12c2.33.79,5.2,1.48,7-.18a7.07,7.07,0,0,0,1.72-4l31.29-155.1c4.12-20.43,8.26-41.26,6-62A134.36,134.36,0,0,0,1457.18,733.55Zm-73.62,67-2.73,13.47c0-.66,0-1.32-.08-2q-1.89-31.92-3.77-63.83l-.79-13.31A143.49,143.49,0,0,1,1383.56,800.59Z"
        />
        <polygon
          className="cls-29"
          points="784.49 860.34 777.68 907.65 960.73 911.97 927.95 830.7 784.49 860.34"
        />
        <path
          className="cls-29"
          d="M801.06,673.54S747,819,689.32,836.83C616,859.45,597.9,666.25,597.9,666.25l35.84-12.79s37.57,107.75,52.33,97.74,55.81-111.28,55.81-111.28,10.11-25,54.19-6.95C837,649.73,801.06,673.54,801.06,673.54Z"
        />
        <path
          className="cls-29"
          d="M587.07,570.32c6.61-8.28,11.78,25.59,15.67,19.66s-2.41-34.23-6-41.91-8.58-17.37,2.53-16.24c4.54.46,11.06,10,17.35,22a44.9,44.9,0,0,0-1.18-5.54c-2.46-8.1-6.09-18.4,4.76-15.73s17.94,57.36,18.53,71.64a59.94,59.94,0,0,1-3.94,23.22c-.74,3-1.57,5.62-2.25,7.57-2.15,6.2,3.63,22.54,3.63,22.54l0,0,10.43,30.5s-40.55,33.24-44.55,14.81c-5.28-24.32-8.22-69.65-8.22-69.65s-2.68-4.69-6.47-13C582.71,610,582.07,576.59,587.07,570.32Z"
        />
        <path
          className="cls-29"
          d="M804.87,543.72s7.45,29.86-12.61,55.79c0,0-12.44,37.56,24.48,49.41S883,616.62,883,616.62l-2-25.6s-17.87-53.91-7.18-80.85Z"
        />
        <path
          className="cls-14"
          d="M875.13,492.05s-70.32,52-64.23,51.32c53.24-6.31,60.51,4.86,60.51,4.86S870.9,502.69,875.13,492.05Z"
        />
        <path
          className="cls-29"
          d="M880.13,503c-2.53,3.1-42.47,46.82-70.54,43.32-23.32-2.9-62.74-37.23-53.27-70.08,7.61-26.39-3.7-49.59,5.54-67,22.51-42.38,72.32-44.49,105.32-20.47C907.89,418.39,896.9,482.45,880.13,503Z"
        />
        <circle className="cls-30" cx="823.07" cy="478.06" r="16.43" />
        <path
          className="cls-31"
          d="M782.88,370.83c-3.59,1.32-8.31,7.11-10,10.55-5,10.28-22.08,34.49-1.12,55.81,29.84,30.35,58.32-1.57,55.2,7s-7.13,27.87,7.41,33.5c31.91,12.37,8.33,60.28,32.75,41.11,42.25-33.17,56.8-63.62,45.36-105.59-5.2-19.08-10.66-36.57-27.39-45.93-14.65-8.19-34.81-20.84-52.24-17.43C815.23,353.31,799.62,364.7,782.88,370.83Z"
        />
        <path className="cls-32" d="M801.36,522.85s14.09,2.71,24.83-16.55" />
        <path
          className="cls-33"
          d="M784.22,460.1c-4.4,6.42-6.22,22.78-6.47,27.17-.14,2.64-.21,5.49,1,7.68,1.83,3.18,5.58,3.6,8.82,3.68,3.53.08,7.67-.24,9.6-3.73a13.42,13.42,0,0,0,1.17-6.41,86.48,86.48,0,0,0-2.23-19.82c-.69-3-1.59-6-3.4-8.17C789.2,456.18,786.39,456.92,784.22,460.1Z"
        />
        <path
          className="cls-29"
          d="M855.22,440a4.65,4.65,0,0,1,.49-2.33c.77-1.57,1.87-3.76,3.31-4.83a12.28,12.28,0,0,1,5.33-2.67,9.43,9.43,0,0,1,5.59,1.23,18.7,18.7,0,0,1,8,8.32,21.88,21.88,0,0,1,2.07,11.44c-.61,7.43-4.62,14.08-8.53,20.41a8.1,8.1,0,0,1-2.6,3,5,5,0,0,1-4.09.21,9.06,9.06,0,0,1-3.43-2.42,19.29,19.29,0,0,1-5.4-14.34,36.89,36.89,0,0,0,.73-6.38,34.42,34.42,0,0,0-.25-6.09C856.22,443.51,855.29,441.76,855.22,440Z"
        />
        <path
          className="cls-14"
          d="M866.45,442.38c7.13,3.43,5,11.77,1.8,17.2a1.46,1.46,0,0,0,2.51,1.47c4-6.79,5.73-17.06-2.84-21.18-1.68-.81-3.16,1.7-1.47,2.51Z"
        />
        <path
          className="cls-34"
          d="M794.05,577.58s-4.66-1.27-3.81,6.15-6.81,9.61-5.63,17.07,110.32,6.11,109.14,0-6.49-2.65-5.9-9.1,4.72-11.92-1.18-14.2S794.05,577.58,794.05,577.58Z"
        />
        <path
          className="cls-34"
          d="M788,598.59s-55.94,7.48-55.94,31.37.57,82.83,17,102.59,5.45,132.85,5.45,132.85,226.71,45.88,219.3-6-40-100.15-37.51-136.2,39.5-132-45.35-126.38C847.12,599.74,788,598.59,788,598.59Z"
        />
        <circle className="cls-35" cx="861.89" cy="473.45" r="3.87" />
        <circle className="cls-35" cx="866.25" cy="477.8" r="3.87" />
        <circle className="cls-35" cx="867.12" cy="472.35" r="3.87" />
        <path
          className="cls-36"
          d="M960.71,903.31l1.65-5.53-195.07,2.69.87,13.88c-13,65.45-103.78,530-75,573.21h154.2l33.39-309.84,82,309.84s132.39,1.18,162.24,0C1153.56,1486.43,976,949.31,960.71,903.31Z"
        />
        <rect
          className="cls-37"
          x="898.65"
          y="328.17"
          width="4.19"
          height="143.69"
          rx="2.1"
          transform="translate(1883.74 328.87) rotate(151.91)"
        />
        <circle className="cls-31" cx="928.62" cy="379.47" r="53.02" />
        <circle className="cls-37" cx="866.86" cy="343.4" r="4.97" />
        <circle className="cls-37" cx="871.48" cy="349.4" r="3.75" />
        <path
          className="cls-29"
          d="M978.79,657.49c13.27-6.67,23.34,27.21,35.2,43.56,11.31,15.58,22.5,138.16,22.5,138.16s20.91,168-19.94,217.25c0,0-2-26.82-22-28.14,3.42-30.81-.18-55.25,1.38-85.86,1.76-34.41-.13-65.3-10.22-96.81-12.94-40.39-15.17-106-21.56-148.64C963.14,690.53,966.85,663.47,978.79,657.49Z"
        />
        <path
          className="cls-29"
          d="M998.38,1126.21c-10.14,4.84.61-29.84-5.84-26S979,1134,978.83,1142.94s.15,20.53-9.92,14.31c-4.12-2.54-5.93-14.63-6.35-29a46.5,46.5,0,0,0-1.44,5.83c-1.41,8.86-2.71,20.36-11.82,12.8s9.43-63,15.48-76.88a63.36,63.36,0,0,1,14.5-20.31c2.12-2.56,4.1-4.63,5.65-6.18,4.92-4.91,7-23.16,7-23.16h0l4.18-33.9s48-22.25,43.27-2.82c-6.23,25.62-18.34,79.51-18.34,79.51s.39,5.72.15,15.39C1020.9,1090.4,1006.05,1122.55,998.38,1126.21Z"
        />
        <path
          className="cls-38"
          d="M594.32,671.24l46.95-14.57s34.06,87.6,43.25,79.55,25.87-121.58,71.8-129.52l16.8,262.17-41.65,6L734,811.37s-26,74.25-71.59,34.89S594.32,671.24,594.32,671.24Z"
        />
        <path
          className="cls-38"
          d="M991.9,1020.33l47.8,7.47S1069,708.44,961,605.91c-11.92-11.32-64-9.32-64-9.32L921.6,889s35.89-6.1,44.5-11.56Z"
        />
        <path
          className="cls-16"
          d="M1206.3,372.89c5.07,4.64,20.16,18.27,25.87,30.6a2.05,2.05,0,0,0,3.91-.76l2.36-40.29a2.06,2.06,0,0,0-2.88-2l-28.68,9.06A2.05,2.05,0,0,0,1206.3,372.89Z"
        />
        <path
          className="cls-39"
          d="M1128.74,256.1l-21.69-5.84c-8.82-2.37-8.82-14.9,0-17.28l21.69-5.84a8.94,8.94,0,0,0,6.31-6.31l5.84-21.68c2.38-8.83,14.9-8.83,17.28,0l5.84,21.68a8.94,8.94,0,0,0,6.31,6.31L1192,233c8.83,2.38,8.83,14.91,0,17.28l-21.69,5.84a9,9,0,0,0-6.31,6.31l-5.84,21.69c-2.38,8.83-14.9,8.83-17.28,0l-5.84-21.69A9,9,0,0,0,1128.74,256.1Z"
        />
        <path
          className="cls-39"
          d="M538.53,960.46l-8.27-2.23a3.41,3.41,0,0,1,0-6.59l8.27-2.22a3.43,3.43,0,0,0,2.41-2.41l2.22-8.27a3.41,3.41,0,0,1,6.59,0L552,947a3.4,3.4,0,0,0,2.4,2.41l8.27,2.22a3.41,3.41,0,0,1,0,6.59l-8.27,2.23a3.38,3.38,0,0,0-2.4,2.41l-2.23,8.26a3.41,3.41,0,0,1-6.59,0l-2.22-8.26A3.41,3.41,0,0,0,538.53,960.46Z"
        />
        <circle className="cls-39" cx="198.99" cy="315.1" r="18.65" />
        <circle className="cls-6" cx="1082.36" cy="740.36" r="24.59" />
        <path
          className="cls-37"
          d="M1188.59,516.3l.34,3.89a1.27,1.27,0,0,0,.61,1c4.47,2.73,37.12,20.36,64.61-.52a1.28,1.28,0,0,0,.48-1.25l-1-5.45a1.26,1.26,0,0,0-2-.77c-5.32,3.94-25.58,14.53-61.32,1.83A1.27,1.27,0,0,0,1188.59,516.3Z"
        />
      </g>
      <path
        className="cls-19"
        d="M68.47,1100.08c-12.19-.19,15-28.73,6.88-28.1s-29.48,26.29-34,34.93-9.77,20-16.56,9.14c-2.78-4.47,1.3-17.1,7.84-31.3a51.63,51.63,0,0,0-4.22,5c-5.65,7.94-12.47,18.49-17.67,6.74s39.6-56.71,52.19-67.3a69,69,0,0,1,23.91-12.76c3.3-1.47,6.23-2.52,8.48-3.28,7.16-2.4,18-19.16,18-19.16h0l20.43-31s58.81,13.53,44.84,30.15c-18.43,21.92-57.63,56.5-57.63,56.5s-2.39,5.75-7.29,15C107.68,1076.13,77.7,1100.23,68.47,1100.08Z"
      />
      <path
        className="cls-13"
        d="M1024.62,154.34c-10.72-9.19-9,36.46-15.61,29.67s-5.4-45.44-2.65-56.39,6.9-24.9-7.37-20.64c-5.83,1.74-12,15.83-17.22,33.18a59.55,59.55,0,0,1,.16-7.56c1.19-11.22,3.38-25.62-10.16-19.42s-9.18,79.62-6.39,98.47a79.92,79.92,0,0,0,11,29.44c1.74,3.8,55.14-2.66,55.14-2.66s2.34-6.81,5.23-18.64C1040.25,205.23,1032.74,161.3,1024.62,154.34Z"
      />
      <path
        className="cls-19"
        d="M261,847.38s-76.51,174.1-140,202.27c0,0,8.52-40.76-10.38-51.73,18.21-28.33,26.52-53.84,42.82-82.86,18.33-32.63,31.41-63.59,36.81-99.11C197.18,770.41,261,847.38,261,847.38Z"
      />
    </svg>
  )
}
